import React from 'react';

import { Skeleton } from '@material-ui/lab';

type LoadingSkeletonProps = {
  lines: number;
};

const getRandomArbitrary = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min) + min);

export const LoadingSkeleton = ({ lines }: LoadingSkeletonProps) => {
  const chunks = Math.floor(lines / 6);
  const leftover = lines % 6;
  return (
    <>
      {Array.from(Array(chunks)).map((_value, index) => (
        // These will be the same as things update because the array length won't change between renders
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="u-padding">
          <h3 className="u-margin-bottom-sm">
            <Skeleton animation="wave" style={{ width: '55%' }} />
          </h3>
          <p className="u-margin-bottom-sm">
            <Skeleton animation="wave" style={{ width: '80%' }} />
            <Skeleton animation="wave" style={{ width: '90%' }} />
            <Skeleton animation="wave" style={{ width: '83%' }} />
            <Skeleton animation="wave" style={{ width: '80%' }} />
          </p>
          <div>
            <Skeleton animation="wave" style={{ width: '70%' }} />
          </div>
        </div>
      ))}
      {leftover ? (
        <div className="u-padding">
          {Array.from(Array(leftover)).map((_value, index) => (
            <Skeleton
              // These will be the same as things update because the array length won't change between renders
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              animation="wave"
              style={{ width: `7${getRandomArbitrary(0, 9)}%` }}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};
